import axios from "axios";

// create an axios instance
const service = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // url = base url + request url
  // timeout: 5000 // request timeout
});

// request interceptor do something before request is sent
service.interceptors.request.use(
  (config) => {
    var userData = JSON.parse(localStorage.getItem("userData"));
    config.headers = {
      "content-type": "application/json",
      // "X-Requested-With": "XMLHttpRequest",
      "Access-Control-Allow-Origin": "*",
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response interceptor

export default service;
